import React, {useContext} from 'react'
import AppContext from 'utils/app_context'
import { useTranslation } from 'react-i18next'

const ProductsGridHeader = (props) => {
  const {destination_id, filters, pagination, onRemoveFilter, onRemoveAllFilters} = props
  const {user} = useContext(AppContext)
  const {i18n} = useTranslation()

  const destination = user.user_data.user.destinations.find(
    (d) => d.id == destination_id || d.slug == destination_id
  )

  return (
    <div className="d-flex flex-column flex-lg-row p-2">
      <div className="me-auto text-secondary mb-2 mb-lg-0">
        <span className="h4 me-2">{destination && i18n.t('products_grid_header.destination_products', {destination: destination.name})}</span>
        {pagination.total_items > 0 &&
          <strong className="h5">({pagination.total_items})</strong>
        }
      </div>
      {filters && filters.length > 0 &&
        <>
          <div className="grid-filter-items">
            {filters.map((filter) => (
              <button
                key={filter.param}
                data-param={filter.param}
                onClick={onRemoveFilter}
                type="button"
                className="btn btn-sm me-2 bg-light mb-2 mb-lg-0"
              >
                {filter.label}{' '}
                <span className="badge bg-light text-dark ms-1">
                  <i className="fa fa-times"></i>
                </span>
              </button>
            ))}
          </div>
          <div className="remove-all-filters">
            <button
              onClick={onRemoveAllFilters}
              type="button"
              className="btn btn-secondary btn-sm w-100 mb-2 mb-lg-0"
            >
              {i18n.t('format:actions.remove_filters')}{' '}
              <span className="badge bg-light text-dark ms-1">
                <i className="fa fa-times"></i>
              </span>
            </button>
          </div>
        </>
      }
    </div>
  )
}

export default ProductsGridHeader
